import {
  ITEMS_GET,
  ITEM_PUSH,
  CLOSE_LIVE_ITEM,
  ITEMS_LOADING,
  ITEMS_UPDATE
} from 'types/actions/items'
import { isEmpty } from 'lodash'
import update from 'immutability-helper'
import { ITEMS_BIDS_SET } from 'types/actions/items'
import { ITEMS_BIDS_CLEAR } from 'types/actions/items'
import { ITEMS_SET_BID_ID } from 'types/actions/items'
import { ITEMS_BIDS_LOADING } from 'types/actions/items'
import { ITEMS_BIDS_PUSH } from 'types/actions/items'
import { ITEMS_BIDS_REMOVE } from 'types/actions/items'

import { ITEMS_PURCHASES_SET } from 'types/actions/items'
import { ITEMS_PURCHASES_CLEAR } from 'types/actions/items'
import { ITEMS_SET_PURCHASE_ID } from 'types/actions/items'
import { ITEMS_PURCHASES_LOADING } from 'types/actions/items'
import { ITEMS_PURCHASES_PUSH } from 'types/actions/items'
import { ITEMS_PURCHASES_REMOVE } from 'types/actions/items'

const engagements = [
  {
    id: 1,
    user_id: 697,
    user_phone: '+18434605262',
    amount: 10000,
    user_name: 'Andrew Strickland',
    type: 'purchase'
  },
  {
    id: 2,
    user_id: 697,
    user_phone: '+18434605262',
    amount: 2150,
    user_name: 'Shanon Caulk',
    type: 'bid'
  },
  {
    id: 3,
    user_id: 13193,
    user_phone: '+18436376960',
    amount: 100,
    user_name: 'Jordan Riser',
    type: 'donation'
  },
  {
    id: 4,
    user_id: 697,
    user_phone: '+18434605262',
    text: 'Wow amazing work everyone!',
    user_name: 'Sam Staley',
    type: 'chat'
  },
  {
    id: 5,
    user_id: 13193,
    user_phone: '+18436376960',
    text: 'I love this item!',
    user_name: 'Jordan Riser',
    type: 'chat'
  },
  {
    id: 6,
    item_id: 115909,
    status: 2,
    item_name: 'Fixed',
    item_type: 'auction',
    type: 'item',
    high_bid_data: {
      high_bid_user_id: 13193,
      high_bid_user_phone: '+18436376960',
      high_bid_user_name: 'Jordan Riser'
    }
  },
  {
    id: 7,
    item_id: 114856,
    status: 1,
    item_name: 'Live Item Live Item Live Item Live',
    item_type: 'auction',
    type: 'item',
    high_bid_data: {
      high_bid_user_id: 697,
      high_bid_user_phone: '+18434605262',
      high_bid_user_name: 'Sam Staley'
    }
  }
]

const itemsInitialState = {
  items: [],
  bids: null,
  purchases: null,
  bidsLoading: false,
  loading: true,
  liveItem: {},
  currentWinner: 0,
  fixedItemSuccessDialogOpen: false,
  bidIds: {},
  purchaseIds: {},
  engagementsLoading: false,
  engagements
}

export default (state = itemsInitialState, action) => {
  let liveItem = itemsInitialState.liveItem
  switch (action.type) {
    case ITEMS_GET:
      liveItem = action.items.find(x => x.is_live)
      return {
        ...state,
        items: action.items,
        liveItem,
        currentWinner: liveItem
          ? liveItem.high_bid_user_id
          : itemsInitialState.currentWinner
      }
    case ITEM_PUSH:
      let item = action.item
      if (item.image === []) {
        item.image = {
          auctionCode: state.event.event.auction_code,
          fullSizeUrl:
            '//res.cloudinary.com/bidr/image/upload/fl_lossy,f_auto,d_eg_placeholder_xhn1xm.png//56394/eg_placeholder_xhn1xm',
          isMarketplaceItem: null,
          original_image_name: 'eg_placeholder_xhn1xm',
          square_full_url:
            '//res.cloudinary.com/bidr/image/upload/w_570,h_570,c_fill,g_auto,fl_lossy,f_auto,d_eg_placeholder_xhn1xm.png//56394/eg_placeholder_xhn1xm',
          square_url:
            '//res.cloudinary.com/bidr/image/upload/w_360,h_360,c_fill,g_auto,fl_lossy,f_auto,d_eg_placeholder_xhn1xm.png//56394/eg_placeholder_xhn1xm',
          thumb_url:
            '//res.cloudinary.com/bidr/image/upload/w_150,h_150,c_thumb,g_auto,fl_lossy,f_auto,d_eg_placeholder_xhn1xm.png//56394/eg_placeholder_xhn1xm',
          url:
            '//res.cloudinary.com/bidr/image/upload/fl_lossy,f_auto,d_eg_placeholder_xhn1xm.png//56394/eg_placeholder_xhn1xm'
        }
      }
      liveItem = state.items.find(x => x.is_live)
      return {
        ...state,
        items: [...state.items, item],
        liveItem,
        currentWinner: liveItem
          ? liveItem.high_bid_user_id
          : itemsInitialState.currentWinner
      }
    case ITEMS_SET_BID_ID:
      const foundBidId = state.bidIds[action.bid.user_id]
      if (foundBidId) {
        return state
      } else {
        let last4 = action.bid.user_phone.slice(
          action.bid.user_phone.length - 4
        )
        const bidIdValues = Object.values(state.bidIds)
        const similarLast4 = bidIdValues
          .filter(x => x.toString().indexOf(last4) > -1)
          .map(x => parseInt(x, 10))
          .sort(function(a, b) {
            return b - a
          })
        if (similarLast4.length > 0) {
          if (similarLast4[0].toString().length === 4) {
            last4 = similarLast4[0].toString() + '1'
          } else {
            last4 = similarLast4[0] + 1
          }
        }
        return update(state, {
          bidIds: {
            [action.bid.user_id]: {
              $set: last4
            }
          }
        })
      }
    case ITEMS_BIDS_SET:
      return {
        ...state,
        bids: action.bids
      }
    case ITEMS_BIDS_PUSH:
      return update(state, {
        bids: {
          [state.bids === null ? '$set' : '$push']: [action.bid]
        }
      })
    case ITEMS_BIDS_LOADING:
      return {
        ...state,
        bidsLoading: action.loading
      }
    case ITEMS_BIDS_CLEAR:
      return {
        ...state,
        bids: null
      }
    case ITEMS_BIDS_REMOVE:
      const bidIndex = state.bids.findIndex(b => b.bid_id === action.bidId)
      return update(state, {
        bids: {
          $splice: [[bidIndex, 1]]
        }
      })
    case ITEMS_SET_PURCHASE_ID:
      const foundPurchaseId = state.purchaseIds[action.purchase.user_id]
      if (foundPurchaseId) {
        return state
      } else {
        let last4 = action.purchase.user_phone.slice(
          action.purchase.user_phone.length - 4
        )
        const purchaseIdValues = Object.values(state.purchaseIds)
        const similarLast4 = purchaseIdValues
          .filter(x => x.toString().indexOf(last4) > -1)
          .map(x => parseInt(x, 10))
          .sort(function(a, b) {
            return b - a
          })
        if (similarLast4.length > 0) {
          if (similarLast4[0].toString().length === 4) {
            last4 = similarLast4[0].toString() + '1'
          } else {
            last4 = similarLast4[0] + 1
          }
        }
        return update(state, {
          purchaseIds: {
            [action.purchase.user_id]: {
              $set: last4
            }
          }
        })
      }
    case ITEMS_PURCHASES_SET:
      return {
        ...state,
        purchases: action.purchases
      }
    case ITEMS_PURCHASES_PUSH:
      return update(state, {
        purchases: {
          [state.purchases === null ? '$set' : '$push']: [action.purchase]
        }
      })
    case ITEMS_PURCHASES_LOADING:
      return {
        ...state,
        purchasesLoading: action.loading
      }
    case ITEMS_PURCHASES_CLEAR:
      return {
        ...state,
        purchases: null
      }
    case ITEMS_PURCHASES_REMOVE:
      const purchaseIndex = state.purchases.findIndex(
        b => b.purchase_id === action.purchaseId
      )
      return update(state, {
        purchases: {
          $splice: [[purchaseIndex, 1]]
        }
      })
    case ITEMS_LOADING:
      return {
        ...state,
        loading: action.loading
      }
    case ITEMS_UPDATE:
      const newItems = state.items.map(item => {
        if (item.item_id === action.itemId) {
          Object.keys(action.updates).forEach(key => {
            item[key] = action.updates[key]
          })
        } else {
          if (action.updates.is_live) {
            item.is_live = false
          }
        }
        return item
      })
      liveItem = newItems.find(x => x.is_live)
      return {
        ...state,
        items: newItems,
        liveItem,
        currentWinner: liveItem
          ? liveItem.high_bid_user_id
          : itemsInitialState.currentWinner
      }
    case CLOSE_LIVE_ITEM:
      return {
        ...state,
        liveItem: {
          ...state.liveItem,
          status: 2
        },
        items: state.items.map(item => {
          if (
            !isEmpty(state.liveItem) &&
            item.item_id === state.liveItem.item_id
          ) {
            item = {
              ...item,
              status: 2
            }
          }
          return item
        })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/items.js